/**
 * המיתוג של המערכת — מקור אמת אחד.
 * כל מקום שמציג שם, סלוגן, צבע או לוגו (אפליקציה, מסכי קבלן, PDF,
 * הודעות וואטסאפ, manifest של ה-PWA) קורא מכאן.
 * הצבעים נדגמו ישירות מקובץ הלוגו (brand-assets/source/logo-original.png).
 */
export const BRAND = {
  name: 'ש.א אבטחה',
  tagline: 'שמירה ובטחון',
  /** שורת התיאור של המערכת — מופיעה מתחת ללוגו */
  systemLine: 'ניהול עבודות, קבלנים, וכמויות עובדים',
  /** כותרת מלאה לחלון הדפדפן ול-manifest */
  appTitle: 'ש.א אבטחה — ניהול עבודות',
  shortName: 'ש.א אבטחה',
  description: 'ש.א אבטחה — ניהול עבודות, קבלנים וכמויות עובדים',

  colors: {
    /** כחול-לילה של המשושה — צבע הבסיס */
    navy: '#0B1B2B',
    /** הכהה ביותר בלוגו (טקסט שם החברה) */
    navyDeep: '#081421',
    /** כסף-פלדה של המסגרת */
    steel: '#A7AFB6',
    /** הפס האדום שמתחת ל-ש.א */
    red: '#B92528',
    /** אפור הסלוגן */
    muted: '#848A8D',
    paper: '#F2F4F6',
    white: '#FFFFFF',
  },

  /** נתיבים יחסיים לשורש האתר (apps/web/public) */
  assets: {
    logoFull: '/brand/logo-full.png',
    emblem: '/brand/emblem.png',
  },

  pdf: {
    footer: 'ש.א אבטחה · שמירה ובטחון',
  },

  whatsapp: {
    signature: 'ש.א אבטחה | שמירה ובטחון',
  },
} as const;

export type Brand = typeof BRAND;
